import Vue from 'vue';
import lottery from './lottery.vue';

const LotteryConstructor = Vue.extend(lottery);

let instance = null;

const getAnInstance = () => {
  if (instance) {
    return instance;
  }

  return new LotteryConstructor({
    el: document.createElement('div'),
  });
};

const removeDom = (el) => {
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
};

LotteryConstructor.prototype.remove = function remove() {
  this.show = false;
  instance = null;
  removeDom(this.$el);
};

const Lottery = (options = {}) => {
  instance = getAnInstance();
  instance.message = typeof options === 'string' ? options : options.message;
  instance.sid = options.sid;
  document.body.appendChild(instance.$el);

  return instance;
};

export default Lottery;
